





































export default {
  props: ["cl_item", "cl_history"],
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      create_error: false,
      database_entry: "",
      cl_entry: {},
      checkbox: true,
      select_user: [],
      select_company: [],
      select_view_company: [],
      select_machine_group: "internal", 
      items_user: [],
      items_company: [],
      items_machine_groups: ['public', 'internal'], 
      update_progress: false,
      status_saved: false,

      headers: [
        { text: "created_at", value: "created_at" }, 
        {
          text: "version",
          value: "version",
        },
        { text: "comment", value: "comment" },
       
      ],
    };
  },
  watch: {},
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
    historyList: function() {
      return this.cl_item.entry_history
    }
   
  },
  mounted() {
    console.log(this.cl_history)
  

  },
  destroyed() {},
  methods: {
   
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },
 
  },
};
